import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

import Reveal from "../Reveal/Reveal";
import { about } from "../../data";
import "./about.css";

const About = () => {
  const { name, role, description, resume, social } = about;

  return (
    <div className="about center section">
      {name && (
        <Reveal as="h1" delay={0}>
          Hi, I am <span className="about__name ">{name}.</span>
        </Reveal>
      )}

      {role && (
        <Reveal as="h2" delay={90} className="about__role heading-text">
          A {role}.
        </Reveal>
      )}
      {description && (
        <Reveal as="p" delay={180} className="about__desc">
          {description}
        </Reveal>
      )}

      <Reveal delay={270} className="about__contact center">
        {resume && (
          <a href={resume} target="_blank" rel="noopener noreferrer">
            <span type="button" className="btn btn--outline">
              Resume
            </span>
          </a>
        )}

        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                aria-label="github"
                className="link link--icon"
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label="linkedin"
                className="link link--icon"
              >
                <LinkedInIcon />
              </a>
            )}
          </>
        )}
      </Reveal>
    </div>
  );
};

export default About;
